import registrationInstance from '../instance'

const getSupportData = () => {
	return registrationInstance.get('dealer/supportData')
}

export default getSupportData
